import { configureStore } from "@reduxjs/toolkit";
import RegisterSlice from "./Slice/RegisterSlice";
const store = configureStore({
  reducer: {
    register: RegisterSlice.reducer,
  },
});

export const registerAction = RegisterSlice.actions;

export default store;
